export default __webpack_public_path__ + "static/media/bca-logo.440cb7d6.svg";